module.exports = __webpack_public_path__ + "img/Viper.08aaf39b.png";